<template>
  <div class="fill-height d-flex flex-column align-content-stretch">
    <div class="flex-grow-1 overflow-auto">
      <ParticipantItem
        v-for="(item, index) in users"
        :key="index"
        :participant="item"
      />
    </div>
    <div class="pt-2">
      <v-btn
        class="blue white--text"
        block
        @click="dialogInvitation = true"
        v-if="$route.params.id"
      >
        <v-icon left>mdi-account-multiple-plus-outline</v-icon>
        {{ $t("commons.invite") }}</v-btn
      >
    </div>
    <div class="pt-2">
      <v-btn
        class="blue white--text"
        block
        @click="dialogInvitationSms = true"
        v-if="$route.params.id"
      >
        <v-icon left>mdi-message-alert-outline</v-icon>
        {{ $t("commons.invite_sms") }}</v-btn
      >
    </div>
    <v-dialog
      v-model="dialogInvitation"
      max-width="450px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("commons.invitation") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form
                  ref="form"
                  lazy-validation
                >
                  <v-text-field
                    filled
                    v-model="emailInvite"
                    :label="$t('commons.email')"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                  <v-textarea
                    filled
                    name="input-7-4"
                    :label="$t('commons.invitation')"
                    disabled
                    :value="fullMessage"
                  ></v-textarea>
                </v-form>
                <div class="text-right">
                  <v-btn
                    text
                    @click="clipboard()"
                  >
                    {{ $t("actions.copy", { entity: $t("commons.message").toLowerCase() }) }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="error white--text"
            text
            @click="dialogInvitation = false"
          >
            {{ $t("commons.cancel") }}
          </v-btn>
          <v-btn
            :loading="loading"
            class="blue white--text"
            text
            @click="sendInvitation()"
          >
            <v-icon left>mdi-email-outline</v-icon>{{ $t("commons.invite") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogInvitationSms"
      max-width="450px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("commons.invitation") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form
                  ref="form"
                  lazy-validation
                >
                  <v-text-field
                    filled
                    v-model="smsInvite"
                    :label="$t('commons.phone_number')"
                    :rules="phoneRules"
                    required
                  ></v-text-field>
                  <v-textarea
                    filled
                    name="input-7-4"
                    :label="$t('commons.invitation')"
                    disabled
                    :value="fullMessage"
                  ></v-textarea>
                </v-form>
                <div class="text-right">
                  <v-btn
                    text
                    @click="clipboard()"
                  >
                    {{ $t("actions.copy", { entity: $t("commons.message").toLowerCase() }) }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="error white--text"
            text
            @click="dialogInvitationSms = false"
          >
            {{ $t("commons.cancel") }}
          </v-btn>
          <v-btn
            :loading="loading"
            class="blue white--text"
            text
            @click="sendSmsInvitation()"
          >
            <v-icon left>mdi-email-outline</v-icon>{{ $t("commons.invite") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import config from "@/app.config"
import TeamService from "@/services/TeamService"
import ParticipantItem from "./participants/ParticipantItem.vue"

export default {
  name: "SideBarParticipants",
  components: {
    ParticipantItem
  },
  props: {
    inspection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      emailInvite: "",
      smsInvite: "",
      dialogInvitation: false,
      dialogInvitationSms: false,
      msgInvitation: this.$t("commons.inspection_message"),
      emailRules: [
        v => !!v || this.$t("messages.validator.field_required"),
        v => /.+@.+\..+/.test(v) || this.$t("messages.validator.email_not_valid")
      ],
      phoneRules: [
        v => !!v || this.$t("messages.validator.field_required"),
        v => /^\+\d{1,3}\d{9,14}$/.test(v) || this.$t("messages.validator.phone_not_valid")
      ]
    }
  },
  methods: {
    clipboard() {
      navigator.clipboard.writeText(this.fullMessage)
    },
    hasTrackEnabled(publicationMap) {
      for (const publication of publicationMap.values()) {
        if (publication.track?.isEnabled) return true
      }
      return false
    },
    sendInvitation() {
      if (this.$refs.form.validate()) {
        this.loading = true
        TeamService.sendInvitationMeeting(this, {
          email: this.emailInvite,
          msg: this.msgInvitation,
          invite_url: this.inviteUrl,
          inspection_name: this.inspection.name,
          inspection_start_date: this.inspection.start_date
        })
          .then(r => {
            this.$store.commit("app/message", {
              msg: this.$t("messages.success.sent", { entity: this.$t("commons.invitation") }),
              color: "success"
            })
          })
          .finally(() => {
            this.loading = false
            this.dialogInvitation = false
            this.emailInvite = ""
          })
      }
    },
    sendSmsInvitation() {
      if (this.$refs.form.validate()) {
        this.loading = true
        TeamService.sendSmsInvitationMeeting(this, {
          phone_number: this.smsInvite,
          msg: this.msgInvitation,
          invite_url: this.inviteUrl
        })
          .then(r => {
            this.$store.commit("app/message", {
              msg: this.$t("messages.success.sent", { entity: this.$t("commons.invitation") }),
              color: "success"
            })
          })
          .finally(() => {
            this.loading = false
            this.dialogInvitationSms = false
            this.smsInvite = ""
          })
      }
    }
  },
  computed: {
    inviteUrl() {
      return `${config.general.url}/inspection/meeting/${this.inspection.uuid}`
    },
    fullMessage() {
      return `${this.msgInvitation} : ${this.inviteUrl}`
    },
    users() {
      // Get visio data
      let users = this.$store.state.meeting.visioUsers.map(e => ({
        identity: e.identity,
        isAudioActivated: this.hasTrackEnabled(e.audioTracks),
        isVideoActivated: this.hasTrackEnabled(e.videoTracks),
        isVisioUser: true
      }))

      // Get chat data
      this.$store.state.meeting.chatUsers.forEach(e => {
        let userData = users.find(ud => e.identity === ud.identity)
        if (userData) {
          userData.isChatUser = true
        } else {
          users.push({ identity: e.identity, isChatUser: true })
        }
      })
      return users
    }
  }
}
</script>
